import { useRef, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { api, RequestError } from '../lib/api.js';
import { useToast } from './Toast.js';

/** Shared by the quote preview and detail page, including native save failures. */
export function QuotePdfDownloadButton({ quoteId, quoteNumber, className, children }: {
  quoteId: string; quoteNumber: string | number; className?: string; children?: ReactNode;
}) {
  const { t } = useTranslation();
  const toast = useToast();
  const active = useRef(false);
  const [pending, setPending] = useState(false);
  const download = async () => {
    if (active.current) return;
    active.current = true;
    setPending(true);
    try { await api.download(`/quotes/${quoteId}/pdf`, `quote-${quoteNumber}.pdf`); }
    catch (error) { toast.error(t(error instanceof RequestError ? error.code : 'errors.unknown')); }
    finally { active.current = false; setPending(false); }
  };
  return <button type="button" className={`${className ?? ''} disabled:opacity-60`} disabled={pending} aria-busy={pending} onClick={() => void download()}>
    {children}<span>{t(pending ? 'common.loading' : 'quotes.downloadPdf')}</span>
  </button>;
}
